// @flow

import { KlaviyoTracking } from '../util/klaviyo-tracking';
import { Api } from './api';
import { logGAEvent, logGAUser } from '../util/log-ga';
import { logFacebookEvent } from '../util/facebook-init';
import { JOB_ROLES } from '../util/job-roles';

const Routes = {
  apply: (jobHash: string) => `/apply/${jobHash}`,
  job: (jobHash: string) => `/job/${jobHash}`,
  visit: (jobHash: string) => `/job/${jobHash}/visit`,
  referralApply: (jobHash: string, referralHash: string) => `/apply/${jobHash}/referral/${referralHash}`,
  referral: (referralHash: string) => `/referral/${referralHash}`,
};

export const ApiClient = {
  apply: (
    jobHash: string, source: ?string, sourceId: ?string,
    visitId: number, applicantInfo: Applicant,
  ) => {
    if (applicantInfo.email) {
      KlaviyoTracking.application.identifyUser(applicantInfo.email, applicantInfo.firstName, applicantInfo.lastName);
    }

    return Api.post(Routes.apply(jobHash), {
      source,
      sourceId,
      visitId,
      applicant: applicantInfo,
    })
      .then(async (response) => {
        if (!response.ok) {
          if (!response.body) {
            throw Error(response.statusText);
          } else {
            const body = await response.json();
            throw Error(JSON.stringify(body));
          }
        }
        return response.json();
      })
      .then((data) => {
        logGAUser(applicantInfo.email);
        logGAEvent('Application', 'Applied', data.jobApplicationHash);
        logFacebookEvent('ApplicationStarted', {
          jobApplicationHash: data.jobApplicationHash,
          industryId: data.job.industryId || 0,
          jobRoleId: data.job.jobRoleId || JOB_ROLES.OTHER,
        });
        return data;
      });
  },
  referralApply: (jobHash: string, referralHash: string, visitId: number) =>
  {
    return Api.post(Routes.referralApply(jobHash, referralHash), {
      visitId,
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        const { person } = data;
        KlaviyoTracking.application.identifyUser(person.email, person.firstName, person.lastName);
        logGAUser(person.email);
        logGAEvent('Application', 'Applied', data.jobApplicationHash);
        return data;
      });
  },
  getJob: (jobHash: string) => Api.get(Routes.job(jobHash)),
  logApplicationVisit: (jobHash: string, version: string, source: ?string, sid: ?string) => {
    return Api.post(Routes.visit(jobHash), {
      version,
      source,
      sid,
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      });
  },
  getReferral: (referralHash: string) =>
    Api.get(Routes.referral(referralHash))
      .then(r => r.json()),
};
